import { Playground } from 'docz';
import { Preloader } from "../../../../../src/components/Elements";
import * as React from 'react';
export default {
  Playground,
  Preloader,
  React
};